import { useState, useEffect } from 'react';
import { fetchReservationById } from '@/services/reservationService';

export const useBookingConfirmation = (id) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reservation, setReservation] = useState(null);

  useEffect(() => {
    if (!id) return;

    const getReservation = async () => {
      setLoading(true);
      try {
        const data = await fetchReservationById(id);
        setReservation(data[0]);
      } catch (err) {
        console.error(err);
        setError('Error fetching reservation.');
      } finally {
        setLoading(false);
      }
    };

    getReservation();
  }, [id]);

  const handleSubmit = async (values, on) => {
    setLoading(true);
    setError(null);
    try {
      await on(values);
    } catch (err) {
      console.error(err);
      setError('Invalid booking confirmation. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    reservation,
    handleSubmit,
  };
};
